export const RESET_STORE = 'RESET_STORE'
export const PRIVACY_AGREEMENT_NEEDED = 'PRIVACY_AGREEMENT_NEEDED'
export const UPDATE_APOLLO_REQUEST_COUNT = 'UPDATE_APOLLO_REQUEST_COUNT'
